// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.purge-button[data-v-3f62d076]{\n\tposition: relative;\n}\n.purge-button[data-v-3f62d076]>:last-child {\n\tposition:absolute;\n\tright: -4px;\n\tcolor:var(--main-danger);\n\tfont-size:.8em;\n\tbackground-color:white;\n\tborder-radius: 50%;\n\tbottom: -3px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
